import { TablerIcon } from "@tabler/icons";
import { useTheme } from "styled-components";

import { IconButton, IconButtonProps } from "@sso/ui/IconButton";

interface ProfileTabNavigationButtonProps extends IconButtonProps {
  Icon: TablerIcon;
  onClick?: () => void;
}

export const ProfileTabNavigationButton = ({ Icon, onClick, ...rest }: ProfileTabNavigationButtonProps) => {
  const theme = useTheme();
  return (
    <IconButton
      position="absolute"
      top="0"
      bottom="0"
      bgColor={theme.colors.grey[200]}
      borderRadius="2px"
      margin="0"
      onClick={onClick}
      {...rest}
    >
      <Icon />
    </IconButton>
  );
};
